import React, { Component } from 'react'
import Bar from './Bar'
import ResultsLine from './ResultsLine'
import TopBullet from './TopBullet'

export class Chart2 extends Component {
    getChartLine(line) {
        const { values, colors } = this.props;
        return (
            <div className="line-result">{line}
                <div className="m10"></div>
                {values.map((score, index) => {
                    if (score >= line)
                        if (9 >= score % line && score % line >= 0 && Math.floor(score / line) === 1)
                            return <TopBullet score={score} key={index} bgcolor={colors[index]} />
                        else
                            return <ResultsLine opac={line / 100} key={index} bgcolor={colors[index]} />
                    else
                        return <ResultsLine key={index} bgcolor={"transparent"} />
                })}
            </div>
        )
    }

    getChartLine70() {
        const { values, colors } = this.props;
        return (
            <div className="line-result line-bigger">
                70
                    <div className="result-green">NORMAL</div>
                <div className="bigLine">
                    {values.map((score, index) => {
                        if (score >= 70)
                            if (9 >= score % 70 && score % 70 >= 0 && Math.floor(score / 70) === 1)
                                return <TopBullet score={score} key={index} bgcolor={colors[index]} />
                            else
                                return <ResultsLine score={score} opac={70 / 100} key={index} bgcolor={colors[index]} />
                        else
                            return <ResultsLine key={index} bgcolor={"transparent"} />
                    })}
                </div>
            </div>
        )
    }

    getChartLine100() {
        const { values, colors } = this.props;
        return (
            <div className="onehundred">100
                <div className="m12"></div>
                {values.map((score, index) => {
                    if (score === 100)
                        return <TopBullet score={'100'} key={index} bgcolor={colors[index]} />
                    else
                        return <ResultsLine key={index} bgcolor={"transparent"} />
                })}
            </div>
        )
    }



    render() {
        const { categories } = this.props;
        return (
            <div className="chart2">
                {this.getChartLine100()}
                {this.getChartLine(90)}
                {this.getChartLine(80)}
                {this.getChartLine70()}
                {this.getChartLine(60)}
                {this.getChartLine(50)}
                {this.getChartLine(40)}
                {this.getChartLine(30)}
                {this.getChartLine(20)}
                {this.getChartLine(10)}
                <div className="line-result">&nbsp;&nbsp;0
                <div className="m10"></div>
                    <div className="circleLine">
                        <div className="circleResult"></div>
                    </div>
                    <div className="circleLine">
                        <div className="circleResult"></div>
                    </div>
                    <div className="circleLine">
                        <div className="circleResult"></div>
                    </div>
                    <div className="circleLine">
                        <div className="circleResult"></div>
                    </div>
                    <div className="circleLine">
                        <div className="circleResult"></div>
                    </div>
                    <div className="circleLine">
                        <div className="circleResult"></div>
                    </div>
                </div>
                <div className="containC">
                    <div className="categoriesBar"></div>
                    {categories.map((category, index) => {
                        if (category)
                            return <Bar key={index} name={category} color={this.props.colors[index]} />
                    })}
                </div>

            </div>
        )
    }
}

export default Chart2
